import './style.css';

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { BokehPass } from 'three/examples/jsm/postprocessing/BokehPass.js';

import * as dat from 'dat.gui';
import { gsap } from 'gsap';


// Debug
const debugobject = {};
// const gui = new dat.GUI({ width: 400 });

// Canvas
const canvas = document.querySelector('.webgl');

// Scene
const scene = new THREE.Scene();

// Loaders
let sceneReady = false;

const loadingManager = new THREE.LoadingManager(
    // Loaded
    () => {
        window.setTimeout(() => {
            gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 0.5, value: 0, delay: 0 });
        }, 250);
        window.setTimeout(() => {
            sceneReady = true;
        }, 500);
    },
    // Progress
    (itemUrl, itemsLoaded, itemsTotal) => {
    },
);

const textureLoader = new THREE.TextureLoader(loadingManager);

const dracoLoader = new DRACOLoader(loadingManager);
dracoLoader.setDecoderPath('draco/');

const gltfLoader = new GLTFLoader(loadingManager);
gltfLoader.setDRACOLoader(dracoLoader);

// Overlay
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1);
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms: {
        uAlpha: { value: 1 },
    },
    vertexShader: `
        void main() {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;
        void main() {
            gl_FragColor = vec4(1.0, 1.0, 1.0, uAlpha);
        }
    `,
});
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial);
scene.add(overlay);

// Textures
const bakedTexture = textureLoader.load('./textures/baked.jpg');
bakedTexture.flipY = false;
bakedTexture.encoding = THREE.sRGBEncoding;

// Materials
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture });

// Models
gltfLoader.load(
    './models/house.glb',
    gltf => {
        const bakedMesh = gltf.scene.children.find(child => child.name === 'house');
        bakedMesh.material = bakedMaterial;
        scene.add(gltf.scene);
    },
);

// Points of interest
const points = [
    {
        position: new THREE.Vector3(-6.5, 1, 8),
        camera: new THREE.Vector3(-8, 2, 10),
        element: document.querySelector('.point-0'),
        description: document.querySelector('.description-0'),
        top: '20vh',
        right: '10vw',
    },
    {
        position: new THREE.Vector3(3.5, 5, 5.5),
        camera: new THREE.Vector3(4.5, 6, 10),
        element: document.querySelector('.point-1'),
        description: document.querySelector('.description-1'),
        top: '20vh',
        left: '5vw',
    },
    {
        position: new THREE.Vector3(6, 1.5, 1.5),
        camera: new THREE.Vector3(8, 4, 4),
        element: document.querySelector('.point-2'),
        description: document.querySelector('.description-2'),
        top: '25vh',
        left: '5vw',
    },
    {
        position: new THREE.Vector3(-2, 1.5, -6.5),
        camera: new THREE.Vector3(-6.5, 1.2, -8),
        element: document.querySelector('.point-3'),
        description: document.querySelector('.description-3'),
        bottom: '10vh',
        right: '10vw',
    }
];

const descriptions = document.querySelectorAll('.description');
const hideDescriptions = () => {
    for ( const description of descriptions ) {
        description.classList.remove('visible');
    }
}
canvas.addEventListener('click', () => {
    hideDescriptions();
})

const closeButtons = document.querySelectorAll('.close');

for (const button of closeButtons) {
    button.addEventListener('click', (e) => {
        e.target.parentElement.classList.remove('visible');
    })
}

for (const point of points) {
    point.element.addEventListener('click', () => {
        hideDescriptions();
        updateCamera(point);
        point.description.classList.add('visible');
        point.description.style.top = point.top;
        point.description.style.right = point.right;
        point.description.style.left = point.left;
        point.description.style.bottom = point.bottom;
    });
};

// // test points
// const cubeGeometry = new THREE.BoxGeometry(0.1,0.1,0.1);
// const cubeMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 });
// const cube = new THREE.Mesh(cubeGeometry, cubeMaterial);
// const testObject = {
//     x: -6.5,
//     y: 1,
//     z: 8
// }
// cube.position.set(testObject.x, testObject.y, testObject.z);
// scene.add(cube);

// gui.add(testObject, 'x').min(-10).max(10).step(0.01).onChange(() => {
//     cube.position.x = testObject.x;
// })
// gui.add(testObject, 'y').min(0).max(8).step(0.01).onChange(() => {
//     cube.position.y = testObject.y;
// })
// gui.add(testObject, 'z').min(-10).max(10).step(0.01).onChange(() => {
//     cube.position.z = testObject.z;
// })

// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
};

window.addEventListener('resize', () => {
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();
    
    effectComposer.setSize(sizes.width, sizes.height);
    
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

// Camera
const camera = new THREE.PerspectiveCamera(
    75,
    sizes.width / sizes.height,
    0.1,
    100
);
camera.position.set(0, 6, 20);
scene.add(camera);

const updateCamera = point => {
    // console.log(camera.position.x, camera.position.y, camera.position.z);
    gsap.to(camera.position, { duration: 0.5, x: point.camera.x, ease: "Power2.easeInOut" });
    gsap.to(camera.position, { duration: 0.5, y: point.camera.y, ease: "Power2.easeInOut" });
    gsap.to(camera.position, { duration: 0.5, z: point.camera.z, ease: "Power2.easeInOut" });
};

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.enablePan = false;
controls.maxPolarAngle = Math.PI / 1.9;
controls.minPolarAngle = Math.PI / 4;
controls.minDistance = 10;
controls.maxDistance = 20;
controls.target.y = 2;

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.setClearColor(0xffffff);

// Post processing
let RenderTargetClass = null;

if (renderer.getPixelRatio() === 1 && renderer.capabilities.isWebGL2) {
    RenderTargetClass = THREE.WebGLMultisampleRenderTarget;
} else {
    RenderTargetClass = THREE.WebGLRenderTarget;
}

const renderTarget = new RenderTargetClass(
    800,
    600,
    {
        minFilter: THREE.LinearFilter,
        magFilter: THREE.LinearFilter,
        format: THREE.RGBAFormat,
        encoding: THREE.sRGBEncoding,
    }
)

const effectComposer = new EffectComposer(renderer, renderTarget);
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
effectComposer.setSize(sizes.width, sizes.height);

const renderPass = new RenderPass(scene, camera);
effectComposer.addPass(renderPass);

const bokehPass = new BokehPass(scene, camera, {
    focus: 15,
    // aperture: 0.002,
    // maxblur: 0.002,
    aperture: 0.0006,
    maxblur: 0.003,
    width: sizes.width,
    height: sizes.height,
});
effectComposer.addPass(bokehPass);

// Raycaster

const raycaster = new THREE.Raycaster();

// Animate
const clock = new THREE.Clock();

const tick = () => {
    const elapsedTime = clock.getElapsedTime();

    controls.update();

    if(sceneReady) {
        for (const point of points) {
            const screenPosition = point.position.clone();
            screenPosition.project(camera);

            raycaster.setFromCamera(screenPosition, camera);
            const intersects = raycaster.intersectObjects(scene.children, true);

            if (intersects.length === 0) {
                point.element.classList.add('visible');
            } else {
                const intersectionDistance = intersects[0].distance;
                const pointDistance = point.position.distanceTo(camera.position);

                if (intersectionDistance < pointDistance) {
                    point.element.classList.remove('visible');
                } else {
                    point.element.classList.add('visible');
                };
            };

            const translateX = screenPosition.x * sizes.width * 0.5;
            const translateY = - screenPosition.y * sizes.height * 0.5;
            point.element.style.transform = `translate(${translateX}px, ${translateY}px)`;
        };
    };

    const originPoint = new THREE.Vector3(0,0,0);
    originPoint.project(camera);
    raycaster.setFromCamera(originPoint, camera);
    const bokehIntersects = raycaster.intersectObjects(scene.children, true);
    bokehPass.uniforms.focus.value = bokehIntersects[0] ? bokehIntersects[0].distance : 0;

    effectComposer.render();

    window.requestAnimationFrame(tick);
};

tick();